import React, { Component } from 'react'; //different
// import './loginregis.css';
import Footer from './footer';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;
class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            rewardlist: [],
            activePage: 1,
            isActive: false,
            categorylist: [],
            activeTab: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            pagecount: 1,
            logoimg: "",
            username: "",   // <- ใช้กับ input username
            userid: null,
            showpass: true,
            isUserValid: false,
            isUserValidError: false,
            isPassValid: false,
            point: 0,
            balance: 0,
            products_page_count: 1,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            token: window.localStorage.getItem("token"),
            type: "",
            linelink: "",
            amount: "",
            remark: "",
            name: "",
            password: "",   // <- ใช้กับ input password
            left: false,
        }
        this.login = this.login.bind(this);
    }

    changepass = (e) => {
        e.preventDefault();
        this.setState((prev) => ({
            showpass: !prev.showpass,
        }));
    }

    // form submit
    login = async (e) => {
        e.preventDefault();
        await this.validateLoginForm();
    }

    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode === "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode === "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode === "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode === "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }

    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }

    validateLoginForm = async () => {
        const { username, password } = this.state;
        console.log("login with:", username, password);

        // เช็คค่าว่างก่อน
        if (!username || !password) {
            await this.notify("warning", "กรุณากรอกชื่อผู้ใช้และรหัสผ่าน");
            return;
        }

        try {
            const res = await instance.post("/api/v1/userlogin", {
                userid: username,
                password: password,
                System: Systems,
                Function: 'validateLoginForm-navbar.js'
            });

            console.log(res);

            if (res.data.status === 200) {
                await localStorage.setItem('auth_token', res.data.token)

                this.setState({
                    userid: res.data.message?.member_id,
                    username: res.data.message?.playerid,
                    firstname: res.data.message?.firstname,
                    lastname: res.data.message?.lastname,
                    point: res.data.message?.Point,
                    balance: res.data.message?.balance || 0, // ปรับจาก res.databalance ให้ปลอดภัยขึ้น
                    loginstate: true,
                });

                await this.notify("success", 'เข้าสู่ระบบสำเร็จ กำลังเปลี่ยนเส้นทาง');
                setTimeout(() => { window.location.href = '/home' }, 2000)
            }
            else if (res.data.status === 401) {
                Swal.fire({
                    title: 'Error!',
                    text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            }
            else {
                Swal.fire({
                    title: 'Error!',
                    text: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            }
        } catch (error) {
            console.error("login error", error);
            await this.notify("error", "เกิดข้อผิดพลาดระหว่างเข้าสู่ระบบ กรุณาลองใหม่อีกครั้ง");
        }
    }

    async componentDidMount() {
        document.body.className = "";
        document.body.style = "background-color:black"
        document.documentElement.className = "scroll-smooth";
        this.link = document.createElement('link');
        this.link.rel = 'stylesheet';
        this.link.href = './login.css'; // Path to your CSS
        document.head.appendChild(this.link);

        try {
            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {

                    const link3 = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link3.type = 'image/svg+xml';
                    link3.rel = 'icon';
                    link3.href = res.data.tblsetting[0].imglogo;
                    document.getElementsByTagName('head')[0].appendChild(link3);

                    const datas = res.data.message;
                    this.setState({
                        webname: res.data.tblsetting[0].Description,
                        logoimg: res.data.tblsetting[0].imglogo,
                        linelink: datas[1].value,
                        System: res.data.tblcatagoryx[0].System
                    });
                }
            });
        }
        catch (error) {
            //////console.log();
        }
    }

    onChange = (e) => {
        const { name, value } = e.target;

        this.setState(
            {
                [name]: value
            },
            () => {
                if (name === "username") {
                    this.setState({ isUserValid: value.length >= 10 });
                    this.setState({ isUserValidError: value.length >= 4 && value.length < 10 });

                }

                if (name === "password") {
                    this.setState({ isPassValid: value.length >= 6 });
                }
            }
        );
    };


    render() {

        return (
            <div className={isMobile ? "css-14pm9ft" : "css-bar7n8"}>
                <div className="flex-1 flex flex-col bg-black font-NotoSans text-white overflow-hidden w-[428px] mx-auto">
                    <div className="relative flex flex-col flex-1 bg-[#101010] z-0 overflow-hidden">
                        <header className="w-full h-[50px] z-50 bg-black">
                            <div className="w-full h-[50px] flex flex-row justify-between items-stretch px-3 xs:px5">
                                <div className="h-[50px] flex items-center cursor-pointer">
                                    <div className="relative w-[100px] sm:w-[139px] h-[32px]" >
                                        <a href="https://savia88.com/">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    alt="logo"
                                                    src={this.state.logoimg}
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </span>
                                        </a>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <ul className="w-full h-full flex flex-row justify-center items-stretch gap-2">
                                        <li
                                            className="h-full flex flex-col justify-center"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            <a
                                                className="px-2 xs:px-3 py-1.5 rounded-lg text-xs text-center text-[#FEB723] border border-[#D5C5A1]"
                                                href="/register"
                                            >
                                                สมัครสมาชิก
                                            </a>
                                        </li>
                                        <li className="flex flex-col justify-center items-center">
                                            <div
                                                className="flex justify-center items-center text-right z-50"
                                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                            >
                                                <div
                                                    className="relative inline-block text-left"
                                                    data-headlessui-state=""
                                                >
                                                    <div>
                                                        <button
                                                            className="w-full flex justify-center items-center gap-1 px-1 h-[30px] border"
                                                            id="headlessui-menu-button-:r0:"
                                                            type="button"
                                                            aria-haspopup="menu"
                                                            aria-expanded="false"
                                                            data-headlessui-state=""
                                                            style={{
                                                                borderColor: "rgb(213, 197, 161)",
                                                                borderRadius: 8
                                                            }}
                                                        >
                                                            <div
                                                                className="relative w-[20px] h-[20px] rounded-full border"
                                                                style={{ filter: "hue-rotate(-191deg)" }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "block",
                                                                        overflow: "hidden",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        position: "absolute",
                                                                        inset: 0
                                                                    }}
                                                                >
                                                                    <img
                                                                        src="/build/web/igame-index-lobby-wm/img/th.svg"
                                                                        decoding="async"
                                                                        data-nimg="fill"
                                                                        className="rounded-full"
                                                                        style={{
                                                                            maxWidth: "100%",
                                                                            maxHeight: "100%",
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            minHeight: "100%",
                                                                            objectFit: "cover"
                                                                        }}
                                                                    />
                                                                </span>
                                                            </div>
                                                            <div className="transition-all duration-[0.5s]">
                                                                <svg
                                                                    className="w-[18px] h-[18px] text-gray-300"
                                                                    aria-hidden="true"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 24 24"
                                                                    fill="currentColor"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
                                                                        clipRule="evenodd"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div
                                className="z-0 w-full h-[1px] bg-[#F6A32F]"
                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                            />
                            <div />
                        </header>
                        <main className="flex-1 overflow-y-auto flex flex-col justify-start no-scrollbar pb-24 z-40">
                            <div className="max-w-md w-full min-h-full mx-auto pt-2 flex flex-col justify-start items-center bg-[#101010]">
                                <div className="w-full h-[48px] flex items-center px-2 py-3">
                                    <div className="flex-grow text-center font-bold text-[17px] md:text-[25px] leading-[21px]">
                                        เข้าสู่ระบบ
                                    </div>
                                </div>
                                <div className="w-full px-3 pt-2">
                                    {/* bind form submit */}
                                    <form onSubmit={this.login}>
                                        <div className="grid grid-cols-1 gap-4 bg-[#161616] border-[#24221E] border border-solid rounded-lg px-3 py-4">
                                            <div className="w-full">
                                                <div className={this.state.isUserValid ? "Login_borderSuccess__wBctB" : this.state.isUserValidError ? "Login_borderError__mjZJ0" : "Login_borderNone__Lcx0M"}>

                                                    <label
                                                        className="h-[20px] font-medium text-[0.6rem] xs:text-xs leading-[19px] text-transparent bg-clip-text bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]"
                                                        htmlFor="userUsername"
                                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                                    >
                                                        Username
                                                    </label>
                                                    <div className="w-full flex items-center">
                                                        <input
                                                            className="flex-grow font-medium text-xs xs:text-lg placeholder:text-[0.6rem] xs:placeholder:text-[12px] leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0"
                                                            type="text"
                                                            id="userUsername"
                                                            placeholder="กรุณากรอกชื่อผู้ใช้หรือหมายเลขโทรศัพท์ของคุณ"
                                                            name="username"
                                                            autoComplete="username"
                                                            value={this.state.username}
                                                            onChange={this.onChange}
                                                        />
                                                        {this.state.isUserValid && (
                                                            <span className="flex items-center">
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "inline-block",
                                                                        overflow: "hidden",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        position: "relative",
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            maxWidth: "100%"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt=""
                                                                            aria-hidden="true"
                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    <img
                                                                        alt=""
                                                                        src="/build/web/igame-index-lobby-wm/img/completed.png"
                                                                        decoding="async"
                                                                        data-nimg="intrinsic"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%"
                                                                        }}
                                                                    />
                                                                </span>
                                                            </span>

                                                        )}
                                                        {this.state.isUserValidError && (
                                                            <span className="flex items-center">
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "inline-block",
                                                                        overflow: "hidden",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        position: "relative",
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            maxWidth: "100%"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt=""
                                                                            aria-hidden="true"
                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    <img
                                                                        alt=""
                                                                        src="/build/web/igame-index-lobby-wm/img/wrong.png"
                                                                        decoding="async"
                                                                        data-nimg="intrinsic"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%"
                                                                        }}
                                                                    />
                                                                </span>
                                                            </span>

                                                        )}

                                                    </div>
                                                </div>
                                                {this.state.isUserValidError && (
                                                    <>
                                                        <div className="Tooltip_invalid__vGUPd " style={{ "--invalid-color": "#DC3545" }}></div>
                                                        <div
                                                            className="flex justify-start items-start pt-1 gap-2 text-[0.6rem] xs:text-xs"
                                                            style={{ color: "rgb(220, 53, 69)" }}
                                                        >
                                                            <span>ชื่อผู้ใช้ ต้องมีเป็นเบอร์โทรศพท์ 10 ตัวอักษรขึ้นไป</span>
                                                        </div>
                                                    </>
                                                )}

                                            </div>
                                            <div className="w-full">
                                                <div className={this.state.isPassValid ? "Login_borderSuccess__wBctB" : "Login_borderNone__Lcx0M"}>

                                                    <label
                                                        className="h-5 font-medium text-[0.6rem] xs:text-xs leading-[19px] text-transparent bg-clip-text bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]"
                                                        htmlFor="password"
                                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                                    >
                                                        รหัสผ่าน
                                                    </label>
                                                    <div className="flex justify-between items-center gap-2">
                                                        <input
                                                            className="flex-grow h-5 font-medium text-xs xs:text-lg placeholder:text-[0.6rem] xs:placeholder:text-[12px] leading-[14px] bg-transparent placeholder-[#757575] bg-[#100F12] focus:outline-0"
                                                            type={this.state.showpass ? "password" : "text"}
                                                            id="password"
                                                            placeholder="กรุณาใส่รหัสผ่านของคุณ."
                                                            name="password"
                                                            autoComplete="current-password"
                                                            value={this.state.password}
                                                            onChange={this.onChange}
                                                        />
                                                        {this.state.isPassValid && (
                                                            <span className="flex items-center">
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "inline-block",
                                                                        overflow: "hidden",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        position: "relative",
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            boxSizing: "border-box",
                                                                            display: "block",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            maxWidth: "100%"
                                                                        }}
                                                                    >
                                                                        <img
                                                                            alt=""
                                                                            aria-hidden="true"
                                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                width: "initial",
                                                                                height: "initial",
                                                                                background: "none",
                                                                                opacity: 1,
                                                                                border: 0,
                                                                                margin: 0,
                                                                                padding: 0
                                                                            }}
                                                                        />
                                                                    </span>
                                                                    <img
                                                                        alt=""
                                                                        src="/build/web/igame-index-lobby-wm/img/completed.png"
                                                                        decoding="async"
                                                                        data-nimg="intrinsic"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: 0,
                                                                            boxSizing: "border-box",
                                                                            padding: 0,
                                                                            border: "none",
                                                                            margin: "auto",
                                                                            display: "block",
                                                                            width: 0,
                                                                            height: 0,
                                                                            minWidth: "100%",
                                                                            maxWidth: "100%",
                                                                            minHeight: "100%",
                                                                            maxHeight: "100%"
                                                                        }}
                                                                    />
                                                                </span>
                                                            </span>


                                                        )}

                                                        <button type="button" onClick={this.changepass}>
                                                            {/* icon เดิม ไม่เปลี่ยน */}
                                                            <span
                                                                style={{
                                                                    boxSizing: "border-box",
                                                                    display: "inline-block",
                                                                    overflow: "hidden",
                                                                    width: "initial",
                                                                    height: "initial",
                                                                    background: "none",
                                                                    opacity: 1,
                                                                    border: 0,
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    position: "relative",
                                                                    maxWidth: "100%"
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        boxSizing: "border-box",
                                                                        display: "block",
                                                                        width: "initial",
                                                                        height: "initial",
                                                                        background: "none",
                                                                        opacity: 1,
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        maxWidth: "100%"
                                                                    }}
                                                                >
                                                                    <img
                                                                        alt=""
                                                                        aria-hidden="true"
                                                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                                                                        style={{
                                                                            display: "block",
                                                                            maxWidth: "100%",
                                                                            width: "initial",
                                                                            height: "initial",
                                                                            background: "none",
                                                                            opacity: 1,
                                                                            border: 0,
                                                                            margin: 0,
                                                                            padding: 0
                                                                        }}
                                                                    />
                                                                </span>
                                                                <img
                                                                    alt=""
                                                                    src="https://cdn.javisx.com/image/94738787-c6b3-4161-b2d8-6c33782092b9.png"
                                                                    decoding="async"
                                                                    data-nimg="intrinsic"
                                                                    style={{
                                                                        position: "absolute",
                                                                        inset: 0,
                                                                        boxSizing: "border-box",
                                                                        padding: 0,
                                                                        border: "none",
                                                                        margin: "auto",
                                                                        display: "block",
                                                                        width: 0,
                                                                        height: 0,
                                                                        minWidth: "100%",
                                                                        maxWidth: "100%",
                                                                        minHeight: "100%",
                                                                        maxHeight: "100%"
                                                                    }}
                                                                />
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="h-[1px] bg-gradient-to-b from-[#EFD596] via-[#CCBC98] to-[#B7A47C] opacity-10 mx-4 my-6"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        />
                                        <div
                                            className="w-full px-4"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            <button
                                                className={
                                                    this.state.isUserValid && this.state.isPassValid
                                                        ? "Login_buttonLoginSuccess__sMj_t"
                                                        : "Login_buttonLoginNone__EzlqK"
                                                }
                                                type="submit"
                                                disabled={!(this.state.isUserValid && this.state.isPassValid)}
                                            >
                                                เข้าสู่ระบบ
                                            </button>

                                        </div>
                                        {/* <div
                                            className="w-full flex justify-center items-center pt-4"
                                            style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                        >
                                            <button type="button">
                                                <div className="font-[700] text-[11px] leading-[13px] text-transparent bg-clip-text bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]">
                                                    <div className="bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C] bg-[length:100%_0.7px] bg-no-repeat bg-bottom">
                                                        ลืมรหัสผ่าน
                                                    </div>
                                                </div>
                                            </button>
                                        </div> */}
                                        <div className="w-full flex justify-center items-center py-4">
                                            <div
                                                className="w-full flex justify-center items-center"
                                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                            >
                                                <button type="button" href={this.state.linelink} onClick={() => window.open(this.state.linelink, "_blank")}>
                                                    <div className="flex gap-1">
                                                        <div className="font-[400] text-[11px] leading-[13px] text-[#909090]">
                                                            พบปัญหาการใช้งาน ติดต่อเจ้าหน้าที่
                                                        </div>
                                                        <div className="font-[700] text-[11px] leading-[13px] text-transparent bg-clip-text bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C]">
                                                            <div className="bg-gradient-to-b from-[#E1D4B4] to-[#B7A47C] bg-[length:100%_0.7px] bg-no-repeat bg-bottom">
                                                                คลิก
                                                            </div>
                                                        </div>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
                <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-[428px] mx-auto z-50" />
            </div>
        );
    }
}
export default App;
